import React from 'react'
import PropTypes from 'prop-types'
import { useStatusReportContext } from '../../statusReportContext'
import StatusReport from '../../index'

function ClientStatusReportDefaultLayout (props) {
  const { report, statuses, isLoading, refetch, reportExpanded } = useStatusReportContext()

  return (
    <StatusReport
      {...props}
      report={report}
      statuses={statuses}
      loading={isLoading}
      onRefetch={refetch}
      expanded={reportExpanded}
    />
  )
}

ClientStatusReportDefaultLayout.propTypes = {
  defaultExpanded: PropTypes.bool
}

export default ClientStatusReportDefaultLayout
